/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import './PaymentManagement.css';
import { useLocation } from 'react-router-dom';
import ViewPayment from './payment/Payment';
import RoyaltyInfo from './schoolRoyalties/RoyaltyInfo';

const PaymentManagement = () => {
	const [activeTab, setActiveTab] = useState(0);
	const location = useLocation();

	useEffect(() => {
		if (location.state?.resetTab) {
			setActiveTab(0);
		}
	}, [location]);

	const renderContent = () => {
		if (activeTab === 0 && ViewPayment) {
			return <ViewPayment />;
		}
		if (activeTab === 1 && RoyaltyInfo) {
			return <RoyaltyInfo />;
		}
		return null;
	};

	return (
		<>
			<div className="messaging-top-bar">
				<div className="flex mx-auto mr-30 ml-40" style={{ gap: 20 }}>
					<span
						onClick={() => setActiveTab(0)}
						className="cursor-pointer messaging-personal-hd text-1xl font-semibold"
					>
						<h1 className={`${activeTab === 0 ? 'messaging-active-hd' : ''} messaging-hd`}>Payment</h1>
					</span>
					<span
						onClick={() => setActiveTab(1)}
						className="cursor-pointer messaging-personal-hd text-1xl font-semibold"
					>
						<h1 className={`${activeTab === 1 ? 'messaging-active-hd' : ''} messaging-hd`}>
							School Royalties
						</h1>
					</span>
				</div>
			</div>
			{renderContent()}
		</>
	);
};

export default PaymentManagement;
